/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import DistributionChannel from './DistributionChannel';

/**
 * The CampaignControllerDtoAppUpdateRequest model module.
 * @module model/CampaignControllerDtoAppUpdateRequest
 * @version 1.0
 */
class CampaignControllerDtoAppUpdateRequest {
    /**
     * Constructs a new <code>CampaignControllerDtoAppUpdateRequest</code>.
     * @alias module:model/CampaignControllerDtoAppUpdateRequest
     */
    constructor() { 
        
        CampaignControllerDtoAppUpdateRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>CampaignControllerDtoAppUpdateRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CampaignControllerDtoAppUpdateRequest} obj Optional instance to populate.
     * @return {module:model/CampaignControllerDtoAppUpdateRequest} The populated <code>CampaignControllerDtoAppUpdateRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CampaignControllerDtoAppUpdateRequest();

            if (data.hasOwnProperty('appNo')) {
                obj['appNo'] = ApiClient.convertToType(data['appNo'], 'Number');
            }
            if (data.hasOwnProperty('category')) {
                obj['category'] = ApiClient.convertToType(data['category'], 'Number');
            }
            if (data.hasOwnProperty('title')) {
                obj['title'] = ApiClient.convertToType(data['title'], 'String');
            }
            if (data.hasOwnProperty('developer')) {
                obj['developer'] = ApiClient.convertToType(data['developer'], 'String');
            }
            if (data.hasOwnProperty('profileImage')) {
                obj['profileImage'] = ApiClient.convertToType(data['profileImage'], 'String');
            }
            if (data.hasOwnProperty('appUrl')) {
                obj['appUrl'] = ApiClient.convertToType(data['appUrl'], 'String');
            }
            if (data.hasOwnProperty('distributionChannel')) {
                obj['distributionChannel'] = DistributionChannel.constructFromObject(data['distributionChannel']);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>CampaignControllerDtoAppUpdateRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>CampaignControllerDtoAppUpdateRequest</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['title'] && !(typeof data['title'] === 'string' || data['title'] instanceof String)) {
            throw new Error("Expected the field `title` to be a primitive type in the JSON string but got " + data['title']);
        }
        // ensure the json data is a string
        if (data['developer'] && !(typeof data['developer'] === 'string' || data['developer'] instanceof String)) {
            throw new Error("Expected the field `developer` to be a primitive type in the JSON string but got " + data['developer']);
        }
        // ensure the json data is a string
        if (data['profileImage'] && !(typeof data['profileImage'] === 'string' || data['profileImage'] instanceof String)) {
            throw new Error("Expected the field `profileImage` to be a primitive type in the JSON string but got " + data['profileImage']);
        }
        // ensure the json data is a string
        if (data['appUrl'] && !(typeof data['appUrl'] === 'string' || data['appUrl'] instanceof String)) {
            throw new Error("Expected the field `appUrl` to be a primitive type in the JSON string but got " + data['appUrl']);
        }

        return true;
    }


}



/**
 * @member {Number} appNo
 */
CampaignControllerDtoAppUpdateRequest.prototype['appNo'] = undefined;

/**
 * @member {Number} category
 */
CampaignControllerDtoAppUpdateRequest.prototype['category'] = undefined;

/**
 * @member {String} title
 */
CampaignControllerDtoAppUpdateRequest.prototype['title'] = undefined;

/**
 * @member {String} developer
 */
CampaignControllerDtoAppUpdateRequest.prototype['developer'] = undefined;

/**
 * @member {String} profileImage
 */
CampaignControllerDtoAppUpdateRequest.prototype['profileImage'] = undefined;

/**
 * @member {String} appUrl
 */
CampaignControllerDtoAppUpdateRequest.prototype['appUrl'] = undefined;

/**
 * @member {module:model/DistributionChannel} distributionChannel
 */
CampaignControllerDtoAppUpdateRequest.prototype['distributionChannel'] = undefined;






export default CampaignControllerDtoAppUpdateRequest;

